var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const fetchChartData = (apiProps, endpoint, tagname = '') => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(endpoint + objectToQueryString(apiProps), {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
    });
    return response.json();
});
function objectToQueryString(obj) {
    const arr = Object.keys(obj).filter(key => obj[key] && obj[key] !== "").map(key => {
        return `${key}=${encodeURIComponent(obj[key])}`;
    });
    return "?" + arr.join("&");
}
